// LH-18: Enterprise Redesigned Landing Page
import EnterpriseHero from "@/landing/components/EnterpriseHero";
import EnterpriseStatCard from "@/landing/components/EnterpriseStatCard";
import CTA from "@/landing/components/CTA";
import FAQ from "@/landing/components/FAQ";
import Footer from "@/landing/components/Footer";
import Header from "@/landing/components/Header";
import HeroProductDemo from "@/landing/components/HeroProductDemo";
import Plans from "@/landing/components/Pricing";
import ToolsShowcase from "@/landing/components/ToolsShowcase";
import { DesignSystemProvider } from "@/app/providers/DesignSystemContext";
import { useTheme } from "@/app/providers/ThemeContext";
import { Activity, Shield, TrendingUp, Zap } from "lucide-react";

const LandingPage = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const stats = [
    {
      label: "Active Watches",
      value: "24/7",
      accent: "cyan" as const,
      icon: <Activity size={14} />,
    },
    {
      label: "Data Sources",
      value: "50+",
      accent: "green" as const,
      icon: <TrendingUp size={14} />,
    },
    {
      label: "Alert Accuracy",
      value: "99.2%",
      accent: "blue" as const,
      icon: <Shield size={14} />,
    },
    {
      label: "Response Time",
      value: "<2s",
      accent: "cyan" as const,
      icon: <Zap size={14} />,
    },
  ];

  return (
    <DesignSystemProvider className="min-h-screen">
      <div
        className="min-h-screen"
        style={{
          background: isDark ? "#111111" : "#f7f7f5",
          fontFamily: "var(--font-sans)",
        }}
      >
        <Header />

        <main>
          {/* Enterprise Hero */}
          <EnterpriseHero
            headline="Your analyst"
            headlineAccent="never sleeps."
            subheadline="LinkedHash feeds live market data into Claude for deep analysis, then monitors your thesis and alerts you when conditions change."
            primaryCta={{ text: "Start Free Trial", href: "#plans" }}
            secondaryCta={{ text: "See How It Works", href: "#tools" }}
          >
            <HeroProductDemo />
          </EnterpriseHero>

          {/* Stats Section */}
          <section
            className="px-6 sm:px-10 lg:px-16 py-16"
            style={{ background: isDark ? "#111111" : "#f7f7f5" }}
          >
            <div className="max-w-6xl mx-auto">
              <div
                className="grid grid-cols-2 lg:grid-cols-4 gap-4"
                style={{ fontFamily: "var(--font-mono)" }}
              >
                {stats.map((stat, index) => (
                  <EnterpriseStatCard
                    key={stat.label}
                    label={stat.label}
                    value={stat.value}
                    accent={stat.accent}
                    icon={stat.icon}
                    animationDelay={index * 0.05}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* Existing Sections */}
          <div style={{ background: isDark ? "#111111" : "#f7f7f5" }}>
            <ToolsShowcase />
            <Plans />
            <FAQ />
            <CTA />
          </div>

          <Footer />
        </main>
      </div>
    </DesignSystemProvider>
  );
};

export default LandingPage;
